import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import FeaturedProducts from "@/components/FeaturedProducts";
import BrandStory from "@/components/BrandStory";
import OurStory from "@/components/OurStory";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Alluring Aesthetic",
  "url": "https://alluringaesthetic.com",
  "logo": "https://alluringaesthetic.com/logo.png",
  "description": "Premium beauty & cosmetics brand offering luxury lipsticks, eyeliners, highlighters and more.",
  "email": "allurngaesthetic@gmail.com",
  "sameAs": [
    "https://www.instagram.com/tryalluringaesthetic"
  ]
};

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Alluring Aesthetic | Premium Beauty & Cosmetics"
        description="Discover premium cosmetics that enhance your natural beauty. Shop luxury lipsticks, eyeliners, highlighters and more at Alluring Aesthetic."
        path="/"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <FeaturedProducts />
        <BrandStory />
        <OurStory />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
};

export default Index;